export var FILE_STORAGE_REPOSITORY_WEB_CONFIG = 'FILE_STORAGE_REPOSITORY_WEB_CONFIG';